/* Edited by Jonathan <jonathan@birubi.co> */
/* Quick-filter chips: client-side show/hide.

   The chips filter the products already on the page: no request, no reload, no
   URL change. Each grid item publishes its product tags in data-ev-tags, and a
   chip simply hides the items that do not carry its tag.

   Single-select, matching the design: one chip is highlighted at a time and
   "All" clears the filter.

   The chips are real links to Shopify's native tag URL, so with JS off they
   degrade to a normal filtered page load. This script calls preventDefault once
   it takes over.

   Dawn's Filter and Sort controls still re-render the grid over AJAX, which
   replaces the items and would silently drop the active chip's filtering. A
   MutationObserver re-applies it whenever that happens. */
if (!customElements.get('ev-quick-filters')) {
  customElements.define(
    'ev-quick-filters',
    class EvQuickFilters extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('.ev-chip-filter'));
        this.allChip = this.querySelector('[data-ev-filter-all]');
        this.gridContainer = document.getElementById('ProductGridContainer');
        if (!this.chips.length || !this.grid) return;

        this.activeTag = null;
        const preselected = this.chips.find(
          (chip) => chip.dataset.evFilterTag && chip.getAttribute('aria-current') === 'true'
        );
        if (preselected) this.activeTag = preselected.dataset.evFilterTag;

        this.addEventListener('click', this.onClick.bind(this));
        this.watchGrid();
        this.apply(this.activeTag);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      get grid() {
        return document.getElementById('product-grid');
      }

      onClick(event) {
        const chip = event.target.closest('.ev-chip-filter');
        if (!chip || !this.contains(chip)) return;

        event.preventDefault();
        this.apply(chip.dataset.evFilterTag || null);
      }

      /* Dawn swaps the grid's innerHTML when a filter or sort is applied, so the
         freshly rendered items need the active chip re-applied to them. */
      watchGrid() {
        if (!this.gridContainer || !window.MutationObserver) return;
        this.observer = new MutationObserver(() => {
          if (this.activeTag) this.filterItems(this.activeTag);
        });
        this.observer.observe(this.gridContainer, { childList: true, subtree: true });
      }

      apply(tag) {
        this.activeTag = tag || null;
        const shown = this.filterItems(this.activeTag);

        this.chips.forEach((chip) => {
          const chipTag = chip.dataset.evFilterTag || null;
          this.setActive(chip, chipTag === this.activeTag);
        });

        this.updateCount(shown);
      }

      filterItems(tag) {
        const grid = this.grid;
        if (!grid) return 0;

        let shown = 0;
        Array.from(grid.children).forEach((item) => {
          const tags = (item.dataset.evTags || '').split('||');
          const matches = !tag || tags.indexOf(tag) !== -1;
          item.hidden = !matches;
          if (matches) shown += 1;
        });
        return shown;
      }

      setActive(chip, active) {
        chip.classList.toggle('ev-chip-filter--active', active);
        if (active) {
          chip.setAttribute('aria-current', 'true');
        } else {
          chip.removeAttribute('aria-current');
        }
      }

      /* Keep the bar's "N products" honest. The original string is kept so the
         count can be swapped in place, which preserves whatever wording and
         pluralisation the store's locale produced. */
      updateCount(shown) {
        ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
          const el = document.getElementById(id);
          if (!el) return;
          if (el.dataset.evOriginalText === undefined) {
            el.dataset.evOriginalText = el.textContent.trim();
          }
          const original = el.dataset.evOriginalText;
          // Matches the number only. It must end on a digit, so grouping
          // separators like "1 234" are covered without swallowing the space
          // before the following word.
          const number = /\d(?:[\d.,   ]*\d)?/;
          el.textContent = this.activeTag ? original.replace(number, String(shown)) : original;
        });
      }
    }
  );
}
